package pl.decks.personal.components.widgets.button

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonKind
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.thenIf

@Composable
fun IconButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<ButtonKind>? = null,
    content: @Composable () -> Unit,
) = Button(
    onClick = {
        onClick()
        it.stopPropagation()
              },
    modifier = modifier,
    variant = ButtonStylesheet.CircleVariant.thenIf(variant != null, variant!!),
) {
    content()
}
